export default __webpack_public_path__ + "b33f096c8333f2d46de9f18a9b0f7408.svg";